<template>
  <div class="d-flex flex-wrap">
    <v-card
      v-for="tile in tiles"
      :key="tile.label"
      outlined
      class="pa-3 mr-3 mb-2"
      min-width="140"
    >
      <div class="text-h5 font-weight-medium">
        {{ tile.value }}
      </div>
      <div class="text-caption grey--text">
        {{ tile.label }}
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ActivityHeadline',
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    activeReviewCount() {
      return this.reviews.filter((r) => !r.archived).length;
    },
    totalTimeSavedHours() {
      const totalSeconds = this.reviews.reduce(
        (sum, r) => sum + (r.timeSavedSeconds || 0),
        0
      );
      return totalSeconds / 3600;
    },
    totalScreeningVotes() {
      return this.reviews.reduce(
        (sum, r) => sum + (r.screeningVotes || 0),
        0
      );
    },
    totalActiveMembers() {
      return this.reviews.reduce(
        (sum, r) => sum + (r.activeMemberCount || 0),
        0
      );
    },
    tiles() {
      return [
        { label: 'Active reviews', value: this.activeReviewCount },
        {
          label: 'Time saved',
          value: `${this.totalTimeSavedHours.toFixed(1)} h`,
        },
        {
          label: 'Screening votes',
          value: this.totalScreeningVotes,
        },
        {
          label: 'Active members',
          value: this.totalActiveMembers,
        },
      ];
    },
  },
};
</script>
